import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const AlertDialogPrices = ({
  scraping,
  onSaveScraping,
  handleSaveScraping,
}) => (
  <div>
    <Dialog
      fullWidth
      maxWidth="lg"
      open={scraping.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Scraping de Precios</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {' '}
          <TextField
            autoFocus
            fullWidth
            id="standard-basic"
            label="Url"
            value={scraping?.url}
            onChange={(event) => handleSaveScraping('url', event.target.value)}
          />
          <br />
          <br />
          <TextField
            autoFocus
            fullWidth
            id="standard-basic"
            label="Xpath"
            value={scraping?.xpath}
            onChange={(event) => handleSaveScraping('xpath', event.target.value)}
          />
          <br />
          <br />
          <h5>Estado</h5>
          <FormControlLabel
            control={(
              <Switch
                checked={scraping?.estado !== '0'}
                onChange={() => {
                  handleSaveScraping(
                    'estado',
                    scraping?.estado === '0' ? '1' : '0',
                  );
                }}
                name="Estado"
                color="primary"
              />
            )}
            label={scraping?.estado === '0' ? 'Inactivo' : 'Activo'}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => handleSaveScraping('open', false)}
        >
          Cerrar
        </Button>
        <Button color="primary" autoFocus onClick={onSaveScraping}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);

export default AlertDialogPrices;
